import { defineMessages } from 'react-intl'

const scope = `procurify.vendor.features.create-vendor-payment-method.views.VendorPaymentMethodForm`

export default defineMessages({
  nameLabel: {
    id: `${scope}.nameLabel`,
    defaultMessage: 'Payment type name',
  },
  namePlaceholder: {
    id: `${scope}.namePlaceholder`,
    defaultMessage: 'Name of the payment type',
  },
  paymentTypeLabel: {
    id: `${scope}.paymentTypeLabel`,
    defaultMessage: 'Payment type',
  },
  paymentTypePlaceholder: {
    id: `${scope}.paymentTypePlaceholder`,
    defaultMessage: 'Select a payment type',
  },
  paymentTypeRequiredError: {
    id: `${scope}.paymentTypeRequiredError`,
    defaultMessage: 'Payment type is required',
  },
  paymentTypeCheck: {
    id: `${scope}.paymentTypeCheck`,
    defaultMessage: 'Check',
  },
  paymentTypeOther: {
    id: `${scope}.paymentTypeOther`,
    defaultMessage: 'Other (ie: Internet banking, etc...)',
  },
  currencyLabel: {
    id: `${scope}.currencyLabel`,
    defaultMessage: 'Currency',
  },
  currencyPlaceholder: {
    id: `${scope}.currencyPlaceholder`,
    defaultMessage: 'Please select an option',
  },
  currencyRequiredError: {
    id: `${scope}.currencyRequiredError`,
    defaultMessage: 'Currency is required',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  addButton: {
    id: `${scope}.addButton`,
    defaultMessage: 'Add',
  },
})
